import { render, staticRenderFns } from "./labelRectificationList.vue?vue&type=template&id=39fbec62&scoped=true"
import script from "./labelRectificationList.vue?vue&type=script&lang=js"
export * from "./labelRectificationList.vue?vue&type=script&lang=js"
import style0 from "./labelRectificationList.vue?vue&type=style&index=0&id=39fbec62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fbec62",
  null
  
)

export default component.exports